define([
  "marionette",
  "messaging/messenger",
  "moment",
  "./taskWizardModalView",
  "modules/tasks/tasksModel",
  "./taskWizardSettingsPage/taskWizardSettingsPageModule",
  "./taskWizardStepsPage/taskWizardStepsPageModule",
  "./taskWizardLocaleStepsPage/taskWizardLocaleStepsPageModule",
  "./taskWizardDenialNextStepsPage/taskWizardDenialNextStepsPageModule",
  "./taskWizardTemplatePage/taskWizardTemplatePageModule",
], function (
  Marionnete,
  Messenger,
  moment,
  TaskWizardModalView,
  TaskModel,
  TaskWizardSettingsPageModule,
  TaskWizardStepsPageModule,
  TaskWizardLocaleStepsPageModule,
  TaskWizardDenialNextStepsPageModule,
  TaskWizardTemplatePageModule,
) {
  "use strict";

  const FIRST_PAGE = 1;
  const SETTINGS_PAGE = 1;
  const STEPS_PAGE = 2;
  const LOCALE_STEPS_PAGE = 3;
  const DENIAL_NEXT_STEPS_PAGE = 4;
  const TEMPLATE_PAGE = 5;
  const LAST_PAGE = 5;

  return Marionnete.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "taskWizardModal";
      this._setUpVents();
    },
    show: function (task) {
      this.task = task;
      this.activePageNumber = 1;
      this.activeLocaleIndex = 0;
      task.intervals = Messenger.reqres.request("task:intervals:withoutNone");
      task.languages = Messenger.reqres.request("kb:languages");
      task.priorities = Messenger.reqres.request("task:priorities");
      task.touchpoints = Messenger.reqres.request("kb:touchpoints");
      task.taskTemplates = Messenger.reqres.request("task:templates");
      task.userDefaultLanguageId = Messenger.reqres.request("default:response:language");
      task.PRIORITY = TaskModel.PRIORITY;
      task.INTERVAL = TaskModel.INTERVAL;
      this.view = new TaskWizardModalView.view({ model: task });
      this.settingsPage = this.addSubModule(
        new TaskWizardSettingsPageModule({ region: this.view.wizardPage }),
      );
      this.stepsPage = this.addSubModule(
        new TaskWizardStepsPageModule({ region: this.view.wizardPage }),
      );
      this.localeStepsPage = this.addSubModule(
        new TaskWizardLocaleStepsPageModule({ region: this.view.wizardPage }),
      );
      this.denialNextStepsPage = this.addSubModule(
        new TaskWizardDenialNextStepsPageModule({ region: this.view.wizardPage }),
      );
      this.templatePage = this.addSubModule(
        new TaskWizardTemplatePageModule({ region: this.view.wizardPage }),
      );
      this.view.on("back", this._onBack, this);
      this.view.on("cancel", this._onCancel, this);
      this.view.on("done", this._onDone, this);
      this.view.on("next", this._onNext, this);
      this.view.on("show", this.showActivePage, this);
      this.showRegion(this.view, { loading: true, entity: task.taskTemplates });
    },
    _onBack: function () {
      this.activePageModule.commitData();
      if (this.activePageNumber == DENIAL_NEXT_STEPS_PAGE) {
        var languageIds = this.task.get("languageIds");
        if (languageIds.length < 1) {
          this.activePageNumber = STEPS_PAGE;
        } else {
          this.activePageNumber = LOCALE_STEPS_PAGE;
          this.activeLocaleIndex = languageIds.length - 1;
        }
      } else if (this.activePageNumber == LOCALE_STEPS_PAGE) {
        if (this.activeLocaleIndex === 0) {
          --this.activePageNumber;
        } else {
          --this.activeLocaleIndex;
        }
      } else if (this.activePageNumber > FIRST_PAGE) {
        --this.activePageNumber;
      }
      this.showActivePage();
    },
    _onCancel: function () {
      Messenger.vent.trigger("cancel:textbox");
      // Do not save anything, throw it away
      Messenger.vent.trigger("close:modal");
      // Reset to the latest state of task from server
      if (!this.task.isNew()) {
        this.task.fetch();
      }
    },
    _onDone: function () {
      var task = this.task;
      if (Messenger.reqres.request("save:textbox")) {
        if (!this.activePageModule.commitData() || !task.isValid()) {
          return;
        }
        Messenger.vent.trigger("show:saving:display");
        task.saveModel({
          error: function (model, resp) {
            Messenger.vent.trigger("close:saving:display");
            Messenger.showErrorFromResponse(resp);
          },
          success: function () {
            task.dirty = false;
            Messenger.vent.trigger("close:saving:display");
            Messenger.vent.trigger("close:modal");
          },
        });
      }
    },
    _onNext: function () {
      if (!this.activePageModule.commitData()) {
        return;
      }
      const languageIds = this.task.get("languageIds");
      if (this.activePageNumber == STEPS_PAGE) {
        if (languageIds.length < 1) {
          this.activePageNumber = DENIAL_NEXT_STEPS_PAGE;
        } else {
          this.activePageNumber = LOCALE_STEPS_PAGE;
          this.activeLocaleIndex = 0;
        }
      } else if (this.activePageNumber == LOCALE_STEPS_PAGE) {
        ++this.activeLocaleIndex;
        if (this.activeLocaleIndex >= languageIds.length) {
          ++this.activePageNumber;
        } else {
          if (this.activeLocaleIndex === 1) {
            this.task.steps().cloneLanguageStepsToEmptyLocales(this.task.get("languageIds"));
          }
        }
      } else if (this.activePageNumber < LAST_PAGE) {
        ++this.activePageNumber;
      }
      this.showActivePage();
    },
    showActivePage: function () {
      let languageIds;
      switch (this.activePageNumber) {
        case SETTINGS_PAGE:
          this.settingsPage.show(this.task);
          this.activePageModule = this.settingsPage;
          this.view.hideButtons();
          this.view.showNextButton();
          break;
        case STEPS_PAGE:
          this.stepsPage.show(this.task);
          this.activePageModule = this.stepsPage;
          this.view.hideButtons();
          this.view.showNextButton();
          this.view.showBackButton();
          break;
        case LOCALE_STEPS_PAGE:
          languageIds = this.task.get("languageIds");
          this.localeStepsPage.show(this.task, this.activeLocaleIndex);
          this.activePageModule = this.localeStepsPage;
          this.view.hideButtons();
          this.view.showBackButton();
          this.view.showNextButton();
          break;
        case DENIAL_NEXT_STEPS_PAGE:
          this.denialNextStepsPage.show(this.task);
          this.activePageModule = this.denialNextStepsPage;
          this.view.hideButtons();
          this.view.showBackButton();
          this.view.showNextButton();
          break;
        case TEMPLATE_PAGE:
          this.templatePage.show(this.task);
          this.activePageModule = this.templatePage;
          this.view.hideButtons();
          this.view.showBackButton();
          this.view.showDoneButton();
          break;
      }
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "task:create:fromTemplate",
        function (options) {
          let templates;
          if (!options || !options.templateId) {
            console.error("No templateId given to task:create:fromTemplate");
            return;
          }
          if (this.task) {
            templates = this.task.taskTemplates;
          }
          if (!templates) {
            templates = Messenger.reqres.request("task:templates");
          }
          templates.onSynced(function () {
            const template = templates.get(options.templateId);
            if (template) {
              const user = Messenger.reqres.request("user");
              const now = new Date();
              const data = template.toJSON({ saving: true });
              delete data.taskId;
              delete data.id;
              if (options.intentId) {
                data.intentId = options.intentId;
                data.intentName = options.intentName;
              } else {
                delete data.intentId;
                delete data.intentName;
              }
              data.creatorId = user.get("userId");
              data.creator = user.get("userName");
              data.startDate = now;
              data.template = false;
              data.priority = TaskModel.PRIORITY.LOW;
              data.dueDate = moment.utc().add(TaskModel.PRIORITY_DAYS.LOW, "days").toDate();
              if (data.steps) {
                for (var i = 0; i < data.steps.length; ++i) {
                  var step = data.steps[i];
                  delete step.id;
                  delete step.taskId;
                  if (step.assignees) {
                    for (var j = 0; j < step.assignees.length; ++j) {
                      var assignee = step.assignees[j];
                      delete assignee.id;
                      delete assignee.taskStepId;
                    }
                  }
                }
              }
              const task = new TaskModel.task(data, { parse: true });
              this.closeSubModules();
              this.show(task);
            }
          }, this);
        },
        this,
      );
    },
  });
});
